import type { GlobalFilter } from '@/app/_shared/store/search-filter';
import { produce } from 'immer';
import { parse } from 'qs';
import { parseQueryToString } from '@/app/_shared/utils/query-string-utils';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isRecord = (obj: any): obj is Record<string, any> => {
  return obj && typeof obj === 'object' && !Array.isArray(obj) && obj !== null;
};

export const transformQueryToGlobalFilter = (query: Record<string, string | undefined>): GlobalFilter[] | undefined => {
  if (!query) return undefined;

  const _queryFilter = parse(parseQueryToString(query.filter, true) || '', { comma: true });
  const _querySwitchFilter = parse(parseQueryToString(query.switchFilter, true) || '', { comma: true });
  const _queryRangeFilter = parse(parseQueryToString(query.rangeFilter, true) || '', { comma: true });

  try {
    const queryFilter = isRecord(_queryFilter) ? _queryFilter : {};
    const querySwitchFilter = isRecord(_querySwitchFilter) ? _querySwitchFilter : {};
    const queryRangeFilter = isRecord(_queryRangeFilter) ? _queryRangeFilter : {};

    const filters = produce<GlobalFilter[]>([], (draft) => {
      // Handle queryFilter
      for (const [key, value] of Object.entries(queryFilter)) {
        if (Array.isArray(value)) {
          value.forEach((val) => draft.push({ key, code: (val as string) || undefined }));
        } else if (typeof value === 'string') {
          draft.push({ key, code: value || undefined });
        }
      }

      // Handle querySwitchFilter
      for (const [key, value] of Object.entries(querySwitchFilter)) {
        if (typeof value === 'string' && value === 'true') {
          draft.push({ key });
        }
      }

      // Handle queryRangeFilter
      for (const [key, value] of Object.entries(queryRangeFilter)) {
        if (Array.isArray(value) && value.length === 2) {
          const newVal = { from: Number(value[0]), to: Number(value[1]) };
          draft.push({ key, value: newVal });
        }
      }
    });

    return filters.length > 0 ? filters : undefined;
  } catch (error) {
    return undefined;
  }
};
